/* eslint-disable(prettier/prettier) */
// 🔴 DO NOT EDIT — This file is generated.

import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
const DownDoubleArrowSvg = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M12 16.5115L16.073 12.4537C16.2115 12.3154 16.383 12.242 16.5875 12.2337C16.792 12.2254 16.9718 12.2987 17.127 12.4537C17.2718 12.5987 17.3442 12.7744 17.3442 12.9807C17.3442 13.187 17.2718 13.3627 17.127 13.5077L12.6327 18.002C12.5391 18.0955 12.4403 18.1615 12.3365 18.2C12.2326 18.2385 12.1205 18.2577 12 18.2577C11.8795 18.2577 11.7673 18.2385 11.6635 18.2C11.5596 18.1615 11.4609 18.0955 11.3672 18.002L6.87298 13.5077C6.73465 13.3692 6.66131 13.1977 6.65298 12.9932C6.64465 12.7887 6.71798 12.6089 6.87298 12.4537C7.01798 12.3089 7.19365 12.2365 7.39998 12.2365C7.60632 12.2365 7.78198 12.3089 7.92698 12.4537L12 16.5115ZM12 10.5307L16.073 6.47296C16.2115 6.33462 16.383 6.26129 16.5875 6.25296C16.792 6.24462 16.9718 6.31796 17.127 6.47296C17.2718 6.61796 17.3442 6.79362 17.3442 6.99996C17.3442 7.20629 17.2718 7.38196 17.127 7.52696L12.6327 12.0212C12.5391 12.1147 12.4403 12.1807 12.3365 12.2192C12.2326 12.2577 12.1205 12.277 12 12.277C11.8795 12.277 11.7673 12.2577 11.6635 12.2192C11.5596 12.1807 11.4609 12.1147 11.3672 12.0212L6.87298 7.52696C6.73465 7.38846 6.66131 7.21696 6.65298 7.01246C6.64465 6.80796 6.71798 6.62812 6.87298 6.47296C7.01798 6.32812 7.19365 6.25571 7.39998 6.25571C7.60632 6.25571 7.78198 6.32812 7.92698 6.47296L12 10.5307Z"
      fill="currentColor"
    />
  </svg>
)
const ForwardRef = forwardRef(DownDoubleArrowSvg)
export default ForwardRef
